import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
//Services
import { CourseService } from "app/core/services/course.service";
import { CurrentUserService } from "app/core/services/current-user.service";

//Models
import { UserCourse } from "app/core/models/user-course";
import { CustomError } from "app/core/models/custom-error";
import { Loading } from "app/core/models/loading";

import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { User } from "app/core/models/user";

import { AuthService } from "app/core/services/auth.service";

@Component({
  selector: "app-user-home",
  templateUrl: "./user-home.component.html",
  styleUrls: ["../user.shared.scss", "./user-home.component.scss"]
})
export class UserHomeComponent implements OnInit, OnDestroy {
  courseListActive: Array<UserCourse> = [];
  courseListArchived: Array<UserCourse> = [];
  courseListDeleted: Array<UserCourse> = [];
  currentUser: User;

  loading: Loading = new Loading(false, "Loading...");

  //errors
  loadError: CustomError;
  // loadErrorTitle: string = "There were errors while loading coures.";

  currentUserSubscription: Subscription;

  constructor(
    private courseService: CourseService,
    private currentUserService: CurrentUserService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.loading.isLoading = true;

    try {
      this.currentUserSubscription = this.currentUserService.currentUser.subscribe(
        currentUser => {

          // console.log(currentUser);

          this.currentUser = currentUser;

          //Guest is logged in
          if (this.currentUser.id == 0) {

            (async () => {
              //redirect to the course assigned to guest
              const token = localStorage.getItem("guest_token");
              const userData = await this.authService.loginAsGuestUser(token);
              // console.log(userData);

              this.router
                .navigate(["/user/courses", userData.courseId], {
                  queryParams: { token: token }
                })
                .then(() => {
                  this.loading.isLoading = false;
                });


            })();



          }
          else {
            (async () => {
              let courseListData = await this.courseService.getUserCourses();

              courseListData.forEach(course => {

                if (course.isDeleted) {
                  this.courseListDeleted.push(course);
                } else if (course.isArchived) {
                  this.courseListArchived.push(course);
                } else {
                  this.courseListActive.push(course);
                }
              });

              this.loading.isLoading = false;

            })();
          }

        }
      );
    } catch (error) {
      this.loadError = error;
      this.loading.isLoading = false;
    }
  }

  ngOnDestroy() {


    // console.log("On Destroy");
    this.currentUserSubscription.unsubscribe();
  }
}
